import React from 'react'

export const toPersianDigit = a => {
  if (a !== null && a !== null) {
    if (typeof a === 'number') {
      a = a.toString()
    }

    return a.replace(/\d+/g, function(digit) {
      var enDigitArr = [],
        peDigitArr = []

      for (var i = 0; i < digit.length; i++) {
        enDigitArr.push(digit.charCodeAt(i))
      }

      for (var j = 0; j < enDigitArr.length; j++) {
        peDigitArr.push(
          String.fromCharCode(enDigitArr[j] + (!!a && a === true ? 1584 : 1728))
        )
      }

      return peDigitArr.join('')
    })
  }
}

export const PersianNum = ({ children: num }) => <span>{toPersianDigit(num)}</span>

export const persianAlphabeticCompare = (s1, s2) => {
  const persian_alphabet_fix_map = {
    ؤ: 1608.5,
    ئ: 1609.5,
    پ: 1577,
    ة: 1607.5,
    ژ: 1586.5,
    ک: 1603,
    چ: 1580.5,
    گ: 1603.5,
    ی: 1610,
  }

  function compare_char_at_index(i) {
    if (i >= s1.length && i >= s2.length) return 0
    if (i >= s1.length) return -1
    if (i >= s2.length) return 1

    const cmp_value =
      (persian_alphabet_fix_map[s1[i]] || s1.charCodeAt(i)) -
      (persian_alphabet_fix_map[s2[i]] || s2.charCodeAt(i))

    if (!cmp_value) return compare_char_at_index(i + 1)

    return cmp_value
  }

  return compare_char_at_index(0)
}

var persian = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
var english = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

export const toEnglishDigits = char => {
  const index = persian.indexOf(char)

  if (index === -1) {
    return char
  } else {
    return english[index]
  }
}



// WEBPACK FOOTER //
// ./src/helpers/nums.js